exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MUI.Switcher{background-color:transparent;border-radius:10px}.MUI.Switcher .Dialog{height:100%;padding:10px 20px;border-radius:10px}", ""]);
